import { createRoot } from "react-dom/client";
import ClientApp from "./app/ClientApp";
import { maxPlatform } from "./app/services/maxPlatform";
import { registerVisitorPwa } from "./app/services/pwaRegister";
import { ensureIosSafeAreaFallback } from "./app/utils/safeArea";
import "./styles/index.css";

ensureIosSafeAreaFallback();

// Only inside real MAX mini-app — never call bridge stub in plain browser/PWA.
if (maxPlatform.isAvailable()) {
  maxPlatform.bootFullscreen();
}
registerVisitorPwa();

createRoot(document.getElementById("root")!).render(<ClientApp />);
